import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import ListKunjunganPerGroup from "./listKunjunganByGroup";
import { useDispatch, useSelector } from "react-redux";
import { Dna, Watch } from "react-loader-spinner";
import { Label } from "reactstrap";
import ReactPaginate from "react-paginate";
import { getGroupKunjunganByCalonNasabah } from "stores";
import { closeGroupManual } from "stores";
import "./GroupCalonNasabah.css";

function GroupCalonNasabah(data) {
  // console.log(data, "DATA");
  const dispatch = useDispatch();
  const korcab = useSelector((state) => state.korcabReducer);
  const auth = useSelector((state) => state.authReducer);

  const [listGroup, setListGroup] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [idGroupNasabah, setIdGroupNasabah] = React.useState("");
  const [expandedRows, setExpandedRows] = useState({});

  //   const [searchText, setSearchText] = React.useState("");
  const handleAnimationComplete = () => {
    console.log("All letters have animated!");
  };

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleClick = () => {
    dispatch({ type: "SET_DETAIL_NASABAH", data: true });
  };

  const handleDetailsClick = (val) => {
    dispatch({ type: "SET_KUNJUNGAN_BY_GROUP", data: false });
    setIdGroupNasabah(val.idGroupKunjungan);
  };

  const submitCLoseGroup = (idCalonNasabah, idGroupKunjungan) => {
    Swal.fire({
      title: "Masukkan keterangan",
      input: "textarea",
      // inputLabel: "Keterangan",
      inputPlaceholder:
        "Tulis alasan atau keterangan penutupan group kunjungan...",
      inputAttributes: {
        "aria-label": "Tulis keterangan di sini",
      },
      showCancelButton: true,
      confirmButtonText: "Lanjut",
      cancelButtonText: "Batal",
      preConfirm: (keterangan) => {
        if (!keterangan || keterangan.trim() === "") {
          Swal.showValidationMessage("Keterangan tidak boleh kosong!");
        }
        return keterangan;
      },
    }).then((resultInput) => {
      if (resultInput.isConfirmed) {
        const keterangan = resultInput.value;

        Swal.fire({
          title: "Apakah anda yakin ingin mengakhiri group kunjungan ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, akhiri!",
          cancelButtonText: "Batal",
        }).then((resultConfirm) => {
          if (resultConfirm.isConfirmed) {
            closeGroupManual({ idGroupKunjungan, idCalonNasabah, keterangan })
              .then((response) => {
                if (response.data.status === 200) {
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 1000,
                  });
                  getGroupKunjunganByCalonNasabah(dispatch, {
                    page: page + 1,
                    limit: totalPerHalaman,
                    idCalonNasabah,
                  });
                } else {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: response.data.message,
                  });
                }
              })
              .catch((error) => {
                console.error("ERRORRRR", error);
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Terjadi kesalahan saat memproses permintaan.",
                });
              });
          }
        });
      }
    });
  };

  //   const handleFilterChange = () => {
  //     setIsLoading(true);
  //     setPage(0);
  //     getAllCalonNasabah(dispatch, {
  //       page: page + 1,
  //       skip: totalPerHalaman,
  //       cari: searchText,
  //     })
  //       .then((response) => {
  //         setIsLoading(false);
  //       })
  //       .catch((error) => {
  //         setIsLoading(false);
  //         Swal.fire({
  //           icon: "error",
  //           title: "Error",
  //           text: "Terjadi kesalahan saat memuat data.",
  //         });
  //       });
  //   };

  //   const handleKeyDown = (e) => {
  //     if (e.key === "Enter") {
  //       handleFilterChange();
  //     }
  //   };

  //   const handleSearch = (e) => {
  //     setSearchText(e.target.value);
  //   };

  //   const handleClearSearch = () => {
  //     setSearchText("");
  //   };

  //   const handleDetailsClick = (val) => {
  //     dispatch({ type: "SET_DETAIL_NASABAH", data: false });
  //     // dispatch({ type: "SET_DETAIL_PENGAJUAN", data: val });
  //   };

  React.useEffect(() => {
    let tmp =
      korcab.groupKujunganById.docs &&
      korcab.groupKujunganById.docs.map((val) => {
        return {
          ...val,
          action: (
            <div className="action-buttons-group">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Details Group Kunjungan</Tooltip>}
              >
                <Button
                  className="btn-action-custom btn-detail-teal"
                  onClick={() => {
                    handleDetailsClick(val);
                  }}
                >
                  <i className="fas fa-info"></i>
                </Button>
              </OverlayTrigger>
              
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Akhiri Group</Tooltip>}
                >
                  <Button
                    className="btn-action-custom btn-close-red"
                    disabled={val.statusKunjungan === "Done"}
                    onClick={() =>
                      submitCLoseGroup(val.idCalonNasabah, val.idGroupKunjungan)
                    }
                  >
                    <i className="fas fa-ban" style={{ fontSize: "15px" }}></i>
                  </Button>
                </OverlayTrigger>
            </div>
          ),
        };
      });
    setListGroup(tmp);
  }, [korcab.groupKujunganById]);

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const getStatusStyle = (status) => {
    switch (status) {
      case "Progress":
        return {
          fontWeight: "bold",
          backgroundColor: "#FDE5DD",
          textColor: "#F85317",
        };
      case "Done":
        return {
          fontWeight: "bold",
          backgroundColor: "#BAD9FD",
          textColor: "#1776F1",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "56px", // override the row height
        fontFamily: "Poppins, sans-serif",
      },
    },
    headRow: {
      style: {
        minHeight: "50px",
        backgroundColor: "#f8fafc",
        borderBottom: "2px solid #e2e8f0",
        fontFamily: "Poppins, sans-serif",
      },
    },
    headCells: {
      style: {
        fontWeight: "700",
        fontSize: "13px",
        color: "#475569",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        justifyContent: "center",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        justifyContent: "center",
      },
    },
  };

  const colGroupKunjungan = [
    {
      name: "No",
      width: "100px",
      center: true,
      // selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
      selector: (row, index) => index + korcab.groupKujunganById.pagingCounter,
    },
    {
      name: "ID Group Kunjungan",
      minWidth: "290px",
      center: true,
      selector: (row) => row.idGroupKunjungan,
    },
    {
      name: "ID Pinjaman",
      minWidth: "290px",
      center: true,
      selector: (row) => (row.loan === "" ? "-" : row.loan),
    },
    {
      name: "Nopeg Marketing",
      minWidth: "290px",
      center: true,
      selector: (row) => row.marketing.nopeg,
    },
    {
      name: "Marketing",
      minWidth: "290px",
      center: true,
      selector: (row) => row.marketing.nama,
    },
    {
      name: "Status Kunjungan",
      minWidth: "290px",
      center: true,
      selector: (row) => row.statusKunjungan,
      cell: (row) => {
        const badgeClass =
          row.statusKunjungan === "Progress"
            ? "badge-progress"
            : row.statusKunjungan === "Done"
              ? "badge-done"
              : "badge-neutral";
        return (
          <span className={`modern-badge-pill ${badgeClass}`}>
            {row.statusKunjungan}
          </span>
        );
      },
    },
    {
      name: "Keterangan",
      minWidth: "290px",
      center: true,
      wrap: true,
      cell: (row) => {
        const isExpanded = expandedRows[row._id];
        const maxLength = 40;

        const toggleExpanded = () => {
          setExpandedRows((prev) => ({
            ...prev,
            [row._id]: !prev[row._id],
          }));
        };

        const keteranganText = row.keteranganDone || "-";
        const isLongText = keteranganText.length > maxLength;
        const displayedText = isExpanded
          ? keteranganText
          : keteranganText.slice(0, maxLength);

        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              textAlign: "left",
              paddingTop: 5,
              paddingBottom: 5,
            }}
          >
            {displayedText}
            {isLongText && !isExpanded && "... "}
            {isLongText && (
              <span
                onClick={toggleExpanded}
                style={{
                  color: "blue",
                  cursor: "pointer",
                  marginLeft: 5,
                  fontWeight: "bold",
                }}
              >
                {isExpanded ? "Sembunyikan" : "Lihat Selengkapnya"}
              </span>
            )}
          </div>
        );
      },
    },

    // {
    //   name: "keterangan",
    //   minWidth: "290px",
    //   center: true,
    //   wrap: true,
    //   selector: (row) => row.keteranganDone,
    // },
    {
      name: "Aksi",
      minWidth: "200px",
      center: true,
      selector: (row) => row.action,
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getGroupKunjunganByCalonNasabah(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      idCalonNasabah: data.data,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [page, totalPerHalaman]);
  return (
    <>
      {korcab.modalKunjunganByGroup ? (
        <Container fluid>
          <Button
            className="btn-back-custom"
            type="button"
            onClick={handleClick}
          >
            <i className="fas fa-arrow-left"></i>
          </Button>

          <Card className="group-card mb-4">
            <Card.Header className="group-card-header">
              <Card.Title as="h3" className="group-title">
                Profil Detail Nasabah
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <div className="profile-summary-grid">
                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-user-circle"></i> Nama Lengkap
                  </span>
                  <span className="profile-value profile-value-capitalize">
                    {data.value.namaNasabah}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-id-card"></i> NIK
                  </span>
                  <span className="profile-value">{data.value.nik || "-"}</span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-map-marker-alt"></i> Alamat
                  </span>
                  <span className="profile-value profile-value-capitalize">
                    {data.value.alamat || "-"}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-phone-alt"></i> No Handphone
                  </span>
                  <span className="profile-value">
                    {data.value.noHp || "-"}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-calendar-alt"></i> Tanggal Lahir
                  </span>
                  <span className="profile-value">
                    {moment(data.value.tglLahir).format("DD MMMM YYYY")}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-briefcase"></i> Kategori Nasabah
                  </span>
                  <span className="profile-value">
                    {data.value.kategoriNasabah === "1"
                      ? "PNS Biasa"
                      : data.value.kategoriNasabah === "2"
                        ? "PNS Prapurna Bakti"
                        : data.value.kategoriNasabah === "3"
                          ? "Pensiunan"
                          : data.value.kategoriNasabah === "4"
                            ? "PRA THT"
                            : "KPS (Kredit Pensiunan)"}
                  </span>
                </div>

                <div className="profile-item">
                  <span className="profile-label">
                    <i className="fas fa-route"></i> Tipe Kunjungan
                  </span>
                  <span className="profile-value">
                    {data.value.typeKunjungan || "-"}
                  </span>
                </div>
              </div>
            </Card.Body>
          </Card>

          <Row>
            <Col md="12">
              <Card className="group-card">
                <Card.Header className="group-card-header">
                  <Card.Title as="h3" className="group-title">
                    Daftar Group Kunjungan
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  {isLoading ? (
                    <div
                      className="loader-container"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "30vh",
                      }}
                    >
                      <Watch
                        visible={true}
                        height="80"
                        width="80"
                        radius="30"
                        color="#F75D59"
                        ariaLabel="watch-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                      />
                      <p className="text-muted mt-3">
                        Memuat daftar group kunjungan...
                      </p>
                    </div>
                  ) : (
                    <div>
                      {listGroup.length > 0 ? (
                        <DataTable
                          columns={colGroupKunjungan}
                          data={listGroup}
                          customStyles={customStyles}
                          paginationPerPage={totalPerHalaman}
                        />
                      ) : (
                        <div className="text-center py-5">
                          <div
                            className="alert alert-warning border-0 text-warning font-weight-bold mb-4 d-inline-block px-4"
                            style={{
                              background: "#fffbeb",
                              borderRadius: "8px",
                            }}
                          >
                            Maaf, belum ada kunjungan nasabah saat ini.
                          </div>
                          <img
                            src={require("assets/img/sorry.jpg")}
                            alt="Sorry"
                            style={{
                              maxWidth: "200px",
                              borderRadius: "8px",
                              display: "block",
                              margin: "0 auto",
                            }}
                          />
                        </div>
                      )}

                      <div style={{ marginTop: 35 }}>
                        <Row className="align-items-center">
                          <Col
                            xs={12}
                            md={6}
                            className="d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0"
                          >
                            <span
                              style={{
                                fontWeight: "700",
                                color: "#64748b",
                                fontSize: "14px",
                                marginRight: "12px",
                              }}
                            >
                              Baris per halaman:
                            </span>
                            <div style={{ width: "110px" }}>
                              <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                name="Pilih Client"
                                value={options.find(
                                  (option) => option.value === totalPerHalaman,
                                )}
                                onChange={handlePageSizeChange}
                                options={options}
                                placeholder="Rows"
                                isSearchable={false}
                              />
                            </div>
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            className="d-flex justify-content-center justify-content-md-end"
                          >
                            <ReactPaginate
                              forcePage={page}
                              containerClassName="paginations"
                              previousClassName="pages-itemss-containers"
                              previousLinkClassName="pages-links-labelss"
                              nextClassName="pages-itemss-containers"
                              nextLinkClassName="pages-links-labelss"
                              breakClassName="pages-itemss-containers"
                              pageCount={
                                korcab.groupKujunganById.totalPages || 1
                              }
                              pageRangeDisplayed={3}
                              marginPagesDisplayed={1}
                              pageLinkClassName="pages-links-labelss"
                              pageClassName="pages-itemss-containers"
                              activeClassName="activees"
                              activeLinkClassName="aactivess"
                              nextLabel=" > "
                              previousLabel=" < "
                              initialPage={page}
                              disableInitialCallback={true}
                              onPageChange={(val) => {
                                setPage(val.selected);
                              }}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <>
          <ListKunjunganPerGroup data={idGroupNasabah} />
        </>
      )}
    </>
  );
}

export default GroupCalonNasabah;
